import { useState } from "react";
import { useAdminAuthContext } from "./useAdminAuthContext";
import API_URL from "../../api/API";
import { useNavigate } from "react-router-dom";

export const useAdminLogin = () => {
    const navigate = useNavigate();

    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const { dispatch } = useAdminAuthContext();

    const adminLogin = async (email, password) => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await fetch(API_URL.POST_ADMIN_LOGIN, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email, password }),
            });

            const json = await response.json();

            if (!response.ok) {
                setError(json.error || "Login failed. Please try again.");
                return;
            }

            // Save the authenticated admin.
            localStorage.setItem("admin", JSON.stringify(json));

            dispatch({
                type: "ADMIN_LOGIN",
                payload: json,
            });

            // Redirect Priya directly to the Read Time Report.
            const normalizedEmail = email.trim().toLowerCase();

            if (normalizedEmail === "priyaberry66@gmail.com") {
                navigate("/administrator/timereport/read", {
                    replace: true,
                });
            } else {
                // Preserve the existing redirect for everyone else.
                navigate("/administrator/dashboard", {
                    replace: true,
                });
            }
        } catch (error) {
            setError(error.message || "Unable to log in. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    return { adminLogin, isLoading, error };
};